export default "__VITE_ASSET__CG$4kCw1__"